<template>
  <div id="asset">
    <div class="container">
      <div class="tw-mt-12">
        <div class="tw-bg-white tw-px-4 tw-py-12">
          <div class="container tw-bg-white tw-rounded-sm tw-px-4">
            <div v-if="!completeKyc">
              <img
                class="tw-w-16 tw-mx-auto"
                src="@/assets/img/orange-alert.svg"
                alt="orange alert"
              />
              <h3 class="tw-text-center tw-font-bold tw-mt-6">
                Complete Your KYC
              </h3>
              <p
                class="text tw-text-black-light tw-text-center tw-mx-auto tw-mt-5"
              >
                You will be able to create an asset once your KYC is submitted
                and has been approved.
              </p>
              <Btn
                class="md:tw-w-52 tw-mx-auto tw-mt-8"
                title="Submit KYC Documents"
                @click="
                  $router.push({
                    name: 'IdentityVerification',
                  })
                "
              />
            </div>
            <div v-if="completeKyc">
              <img
                class="tw-w-16 tw-mx-auto"
                src="@/assets/img/orange-search-icon.svg"
                alt="orange alert"
              />
              <h3 class="tw-text-center tw-font-bold tw-mt-6">
                We are reviewing your KYC document
              </h3>
              <p
                class="text tw-text-black-light tw-text-center tw-mx-auto tw-mt-5"
              >
                You will be able to create an asset once your KYC is submitted
                and has been approved.
              </p>
              <Btn
                class="md:tw-w-52 tw-mx-auto tw-mt-8"
                title="View KYC Documents"
                @click="
                  $router.push({
                    name: 'IdentityVerification',
                  })
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EmptyState from "@/components/notification/EmptyState.vue";
import Btn from "@/components/general/BtnComponent.vue";
import { getItem } from "@/utils/storage.js";
import { removeDash } from "@/utils/helpers.js";

export default {
  name: "Asset",

  components: { EmptyState, Btn },

  data() {
    return {
      assetId: "",
    };
  },

  computed: {
    ...mapState({
      orgAsset: (state) => state.organisationModule.organisationAsset,
      orgDetails: (state) => state.organisationModule.organisationDetails,
    }),
    completeKyc() {
      if (
        Object.values(this.orgDetails.kyc).includes("") ||
        Object.values(this.orgDetails.kyc).includes("Rejected")
      )
        return false;
      if (
        Object.values(this.orgDetails.kyc).includes("Approved") &&
        Object.values(this.orgDetails.kyc).includes("Pending")
      )
        return true;
      if (
        Object.values(this.orgDetails.kyc).includes("Approved") &&
        Object.values(this.orgDetails.kyc).includes("Approved")
      ) {
        this.$router.push({ name: "CreateAsset" });
        return true;
      }
      if (
        Object.values(this.orgDetails.kyc).includes("Pending") &&
        Object.values(this.orgDetails.kyc).includes("Pending")
      )
        return true;
    },
  },

  created() {
    this.assetId = getItem("org_details").asset;
    this.getOrganisationAsset();
    this.getOrganisationProfile(this.orgDetails._id);
  },

  methods: {
    ...mapActions("organisationModule", [
      "getOrganisationAsset",
      "getOrganisationProfile",
    ]),

    removeDash,
  },
};
</script>

<style lang="scss" scoped>
#asset {
  @include fadeIn;

  @media screen and (min-width: 1024px) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
